import { IFlight } from '@move-frontend/dap';

/**
 * Returns the appropriate timestamp to use for sorting flights.
 *
 * Flights are normally sorted based on their scheduled time.
 * However, if a flight was scheduled in the past (i.e., its scheduled time is before "now"),
 * but its actual (delayed) time is still in the future, we prioritize the actual time for sorting.
 *
 * This ensures that delayed flights (e.g., a flight scheduled 1 hour ago but delayed by 4 hours)
 * still appear correctly in the list of upcoming flights based on their real expected departure.
 *
 * Otherwise, the scheduled time is used as default.
 */
export const getFlightTimeForSorting = (flight: IFlight) => {
	if (
		flight.actualTimestamp &&
		flight.scheduledTimestamp < Date.now() / 1000 &&
		flight.actualTimestamp > Date.now() / 1000
	) {
		return flight.actualTimestamp;
	}

	return flight.scheduledTimestamp;
};
